@let loginSide = headerType()?.['headerType'] ?? 'default';

@if (loginSide === 'default') {
	<app-public-header-cta/>
}

@if (loginSide === 'simple') {
	<app-header/>
}

@if (loginSide === 'withLogin') {
	<app-public-header-login/>
}
@if (loginSide === 'ccfo') {
	<app-custom-header-ccfo/>
}

@if (loginSide === 'legalese') {
	<app-custom-header-legalese/>
}
<div class="container">
	<router-outlet/>
</div>
<app-footer/>
